import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Text,
  Tooltip,
  useToast,
} from '@chakra-ui/react';
import SectionWrapper from '../../pass-templates-new/SectionWrapper';
import CustomVisitUrlIcon from '../../../../theme/icons/CustomVisitUrlIcon';
import CustomCopyIcon from '../../../../theme/icons/CustomCopyIcon';
import CustomToast from '../../../../common/CustomToast';

interface DistributionLinkSectionProps {
  distributionUrl?: string;
}

const DistributionLinkSection = ({
  distributionUrl,
}: DistributionLinkSectionProps) => {
  const toast = useToast();

  return (
    <SectionWrapper
      title="Distribution link"
      openOnLoad
      id="distribution-link-section"
      subtitle={
        <Text fontSize="15px" color="grey">
          Share this link with your customer to download the pass.
        </Text>
      }
    >
      <Box position="relative">
        <Flex direction="column" gap={6}>
          <FormControl>
            <Flex direction="column" gap={2} mt="6px">
              <FormLabel variant="templateBuilderLabel">URL</FormLabel>
              <Flex direction="row" gap={2} alignItems="center">
                <Input
                  variant="readOnlyUrl"
                  bg="#F8F8F8"
                  id="formUrl"
                  type="text"
                  value={distributionUrl}
                  readOnly
                  cursor="text"
                />
                <Tooltip
                  label="Go to URL"
                  hasArrow
                  placement="top"
                  fontSize="12px"
                  bg="inkBlue"
                  color="white"
                  borderRadius="6px"
                  textAlign="center"
                  p="10px"
                >
                  <IconButton
                    icon={<CustomVisitUrlIcon boxSize="20px" />}
                    onClick={() => window.open(distributionUrl, '_blank')}
                    aria-label="Go to URL"
                    variant="ghost"
                    borderRadius="10px"
                    borderColor="#D0D5DD"
                    borderWidth="1px"
                    bg="#F8F8F8"
                    _hover={{
                      bg: '#EEEEEE',
                      '& path': { stroke: '#252525' },
                    }}
                  />
                </Tooltip>
                <Tooltip
                  label="Copy URL"
                  hasArrow
                  placement="top"
                  fontSize="12px"
                  bg="inkBlue"
                  color="white"
                  borderRadius="6px"
                  textAlign="center"
                  p="10px"
                >
                  <IconButton
                    icon={<CustomCopyIcon boxSize="20px" color="#989898" />}
                    onClick={() => {
                      if (!distributionUrl) return;
                      navigator.clipboard.writeText(distributionUrl);
                      toast({
                        render: (props) => (
                          <CustomToast
                            status="success"
                            title="Link copied"
                            description=""
                            onClose={props.onClose}
                            position="top"
                            duration={2000}
                            id={props.id}
                          />
                        ),
                      });
                    }}
                    cursor="pointer"
                    aria-label="Copy URL"
                    variant="ghost"
                    borderRadius="10px"
                    borderColor="#D0D5DD"
                    borderWidth="1px"
                    bg="#F8F8F8"
                    _hover={{
                      bg: '#EEEEEE',
                      '& path': { stroke: '#252525' },
                    }}
                  />
                </Tooltip>
              </Flex>
            </Flex>
          </FormControl>
        </Flex>
      </Box>
    </SectionWrapper>
  );
};

export default DistributionLinkSection;
